// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsOfService_termsOfServiceContainer__iHYTn {
  background-color: var(--color-theme-snow);
  padding: 12px 10px;
  color: var(--color-font-0);
  height: 450px;
  overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.TermsOfService_iframe__TXb8c {
  width: 100%;
  height: 100%;
  /* background-color: var(--color-theme-snow); */
  color: var(--color-font-0);
  border: none;
}

.TermsOfService_accept_container__SQaUL {
  background-color: rgba(240, 240, 240, 0.95);
  position: sticky;
  bottom: 0;
}

@media screen and (max-width: 1280px) {
  .TermsOfService_termsOfServiceContainer__iHYTn {
    height: 350px;
  }
}

@media screen and (min-width: 1440px) {
  html,
  body {
    overflow-y: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/AccountCreation/components/TermsOfService/TermsOfService.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":[".termsOfServiceContainer {\n  background-color: var(--color-theme-snow);\n  padding: 12px 10px;\n  color: var(--color-font-0);\n  height: 450px;\n  overflow: auto;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.iframe {\n  width: 100%;\n  height: 100%;\n  /* background-color: var(--color-theme-snow); */\n  color: var(--color-font-0);\n  border: none;\n}\n\n.accept_container {\n  background-color: rgba(240, 240, 240, 0.95);\n  position: sticky;\n  bottom: 0;\n}\n\n@media screen and (max-width: 1280px) {\n  .termsOfServiceContainer {\n    height: 350px;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  html,\n  body {\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"termsOfServiceContainer": `TermsOfService_termsOfServiceContainer__iHYTn`,
	"iframe": `TermsOfService_iframe__TXb8c`,
	"accept_container": `TermsOfService_accept_container__SQaUL`
};
export default ___CSS_LOADER_EXPORT___;
